import React from 'react';

import '../../scss/ui/NavigationArrow.scss';

const NavigationArrow = (props = {}) => {
	const direction = (props.direction === 'next') ? 'next' : 'prev',
		className = props.className || '';

	return (<a className={`${className ? className + ' ' : ''}carousel-control-${direction}`} href={'#' + (props.id || '')} id={props.id} role="button" data-slide={direction}>
		<span className={`carousel-control-${direction}-icon`} aria-hidden="true"></span>
		<span className="sr-only">{props.label || ''}</span>
	</a>);
}

export default NavigationArrow;